import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="254"
    height="32"
    fill="none"
    viewBox="0 0 254 32"
    className={className}
  >
    <g clipPath="url(#clip0_3586_15559)">
      <path fill="#113050" d="M24.204 15.93l-8.972 9.386-8.97-9.386 8.97-9.386 8.972 9.386z"></path>
      <path fill="#76C6B3" d="M24.204 15.93l1.21 6.533-8.97 9.386-1.212-6.533 8.972-9.386z"></path>
      <path fill="#0075C9" d="M14.014 0L5.043 9.386l1.219 6.544 8.97-9.386L14.015 0z"></path>
      <path fill="#F2B5B6" d="M0 17.204l8.971 9.387 6.261-1.275-8.97-9.386L0 17.204z"></path>
      <path fill="#F8BA17" d="M15.232 6.544l6.254-1.268 8.972 9.386-6.254 1.268-8.972-9.386z"></path>
      <mask
        id="mask0_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask0_3586_15559)">
        <path
          fill="#113050"
          d="M41.439 14.908l-.15-.028c-1.827-.338-3.407-.63-3.407-2.228 0-1.52 1.197-2.502 3.049-2.502 1.776 0 2.926.932 3 2.434l.007.134h2.628l-.004-.147c-.1-3.05-2.382-5.098-5.68-5.098-3.383 0-5.655 2.113-5.655 5.256 0 3.842 2.871 4.372 5.404 4.84l.145.026c1.823.338 3.397.63 3.397 2.23s-1.24 2.554-3.316 2.554c-1.998 0-3.22-.956-3.267-2.558l-.004-.138h-2.728l.004.146c.073 3.174 2.427 5.227 5.995 5.227 3.657 0 6.02-2.083 6.02-5.307.001-3.847-2.89-4.375-5.438-4.841z"
        ></path>
      </g>
      <mask
        id="mask1_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask1_3586_15559)">
        <path
          fill="#113050"
          d="M66.303 11.543c-3.827 0-6.604 2.842-6.604 6.757 0 3.914 2.777 6.756 6.604 6.756 3.826 0 6.603-2.842 6.603-6.756 0-3.915-2.777-6.757-6.603-6.757zm3.996 6.757c0 2.491-1.643 4.233-3.996 4.233-2.354 0-3.997-1.742-3.997-4.233 0-2.492 1.643-4.233 3.997-4.233 2.353 0 3.996 1.74 3.996 4.233z"
        ></path>
      </g>
      <mask
        id="mask2_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask2_3586_15559)">
        <path
          fill="#113050"
          d="M80.546 11.543c-3.8 0-6.069 2.431-6.069 6.502v6.68h2.583v-6.68c0-2.528 1.27-3.978 3.486-3.978s3.487 1.45 3.487 3.978v6.68h2.581v-6.68c0-4.071-2.268-6.502-6.068-6.502z"
        ></path>
      </g>
      <mask
        id="mask3_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask3_3586_15559)">
        <path
          fill="#113050"
          d="M94.79 11.543c-3.827 0-6.604 2.842-6.604 6.757 0 3.914 2.777 6.756 6.604 6.756 2.807 0 5.063-1.469 6.034-3.93l.077-.196h-2.828l-.041.063c-.677 1.05-1.707 1.54-3.243 1.54-2.034 0-3.505-1.222-3.873-3.2h10.429V18.3c0-3.915-2.756-6.757-6.555-6.757zm-3.786 5.342c.483-1.769 1.886-2.818 3.786-2.818 1.92 0 3.332 1.05 3.81 2.818h-7.596z"
        ></path>
      </g>
      <mask
        id="mask4_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask4_3586_15559)">
        <path
          fill="#113050"
          d="M123.651 11.543c-3.826 0-6.603 2.842-6.603 6.757 0 3.914 2.777 6.756 6.603 6.756 2.807 0 5.063-1.469 6.034-3.93l.078-.196h-2.829l-.041.063c-.677 1.05-1.707 1.54-3.242 1.54-2.035 0-3.505-1.222-3.874-3.2h10.429V18.3c0-3.915-2.757-6.757-6.555-6.757zm-3.786 5.342c.484-1.769 1.887-2.818 3.786-2.818 1.92 0 3.332 1.05 3.811 2.818h-7.597z"
        ></path>
      </g>
      <mask
        id="mask5_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask5_3586_15559)">
        <path
          fill="#113050"
          d="M137.093 11.543c-3.378 0-5.315 2.055-5.315 5.637v7.545h2.582V17.18c0-2.066.919-3.113 2.733-3.113 1.787 0 2.732 1.076 2.732 3.113v.296h2.559v-.27c0-3.599-1.929-5.662-5.291-5.662z"
        ></path>
      </g>
      <mask
        id="mask6_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask6_3586_15559)">
        <path
          fill="#113050"
          d="M148.842 11.543c-3.378 0-5.315 2.055-5.315 5.637v7.545h2.582V17.18c0-2.066.92-3.113 2.733-3.113 1.787 0 2.733 1.076 2.733 3.113v.296h2.557v-.27c0-3.599-1.928-5.662-5.29-5.662z"
        ></path>
      </g>
      <mask
        id="mask7_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask7_3586_15559)">
        <path
          fill="#113050"
          d="M164.83 11.874v6.578c0 2.475-1.303 3.953-3.486 3.953-2.216 0-3.487-1.44-3.487-3.953v-6.578h-2.582v6.578c0 4.794 2.934 6.502 5.68 6.502 1.667 0 3.053-.733 3.875-2.031v2.71c0 2.574-1.156 3.826-3.535 3.826-1.727 0-2.823-.654-3.351-1.998l-.034-.088h-2.577l.044.178c.677 2.735 2.834 4.304 5.918 4.304 3.888 0 6.117-2.287 6.117-6.273V11.874h-2.582z"
        ></path>
      </g>
      <mask
        id="mask8_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask8_3586_15559)">
        <path
          fill="#113050"
          d="M109.734 11.564c-1.846 0-3.399.793-4.337 2.192V6.2L102.814 8.9v9.317c0 4.102 2.625 6.859 6.531 6.859 3.902 0 6.627-2.81 6.627-6.834 0-4.384-3.137-6.68-6.238-6.68zm-.365 10.989c-2.338 0-3.972-1.74-3.972-4.233 0-2.492 1.634-4.233 3.972-4.233 2.354 0 3.997 1.741 3.997 4.233 0 2.492-1.643 4.233-3.997 4.233z"
        ></path>
      </g>
      <mask
        id="mask9_3586_15559"
        style={{ maskType: 'luminance' }}
        width="168"
        height="43"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M167.413 0H0v42.257h167.413V0z"></path>
      </mask>
      <g mask="url(#mask9_3586_15559)">
        <path
          fill="#113050"
          d="M56.09 19.826c0 1.771-.826 2.706-2.392 2.706-1.549 0-2.368-.935-2.368-2.706v-5.454h5.033v-2.498H51.33V7.31l-2.582 2.702v9.815c0 3.324 1.804 5.23 4.95 5.23s4.95-1.906 4.95-5.23v-.422H56.09v.422z"
        ></path>
      </g>
      <path
        fill="#0075C9"
        d="M250.898 13.615a1.64 1.64 0 01.456-1.142c.14-.145.304-.26.492-.345.189-.085.39-.128.603-.128.213 0 .413.043.601.128a1.584 1.584 0 01.826.857c.082.197.123.407.123.63 0 .223-.041.432-.123.626a1.592 1.592 0 01-.826.851 1.486 1.486 0 01-.601.124 1.504 1.504 0 01-1.095-.467 1.611 1.611 0 01-.456-1.134zm.245 0a1.416 1.416 0 00.381.964c.118.126.256.224.415.295.159.072.329.107.511.107a1.275 1.275 0 00.924-.402 1.41 1.41 0 00.279-1.498 1.377 1.377 0 00-.279-.434 1.308 1.308 0 00-.415-.292 1.232 1.232 0 00-.509-.107c-.182 0-.352.036-.511.107a1.308 1.308 0 00-.415.292 1.397 1.397 0 00-.381.968zm.7-.917h.613c.081 0 .16.01.237.027.078.02.147.05.208.093a.48.48 0 01.146.164c.036.066.055.149.055.25a.47.47 0 01-.109.323.534.534 0 01-.293.167l.47.797h-.381l-.408-.761h-.225v.76h-.312l-.001-1.82zm.565.796c.09 0 .177-.018.258-.053.082-.036.123-.108.123-.217 0-.1-.038-.166-.112-.2a.584.584 0 00-.236-.049h-.285v.52h.252zM175.154 16.683c0-4.934 3.465-8.56 8.372-8.56 4.115 0 7.219 2.543 8.109 6.293h-3.248c-.746-1.988-2.526-3.297-4.861-3.297-3.127 0-5.244 2.342-5.244 5.564 0 3.221 2.117 5.587 5.244 5.587 2.335 0 4.115-1.333 4.861-3.322h3.248c-.89 3.751-3.994 6.293-8.109 6.293-4.907 0-8.372-3.625-8.372-8.558zM193.583 17.69c0-3.751 2.117-5.538 5.221-5.538s5.197 1.787 5.197 5.588v.076h-2.839v-.126c0-2.015-.963-2.744-2.358-2.744s-2.358.73-2.358 2.744v7.224h-2.863V17.69zM214.778 17.363c-.456-1.662-1.756-2.493-3.32-2.493-1.612 0-2.863.857-3.32 2.493h6.64zm-9.719 1.333c0-3.775 2.647-6.545 6.399-6.545 3.754 0 6.352 2.77 6.352 6.545v1.058h-9.744c.385 1.812 1.708 2.769 3.392 2.769 1.276 0 2.214-.378 2.815-1.184h3.056c-.891 2.366-3.056 3.902-5.871 3.902-3.753 0-6.399-2.77-6.399-6.545zM229.094 18.697c0-2.19-1.396-3.751-3.488-3.751-2.094 0-3.514 1.56-3.514 3.75s1.42 3.751 3.514 3.751c2.092 0 3.488-1.56 3.488-3.75zm-9.889-.127c0-4.254 3.032-6.419 5.919-6.419 1.708 0 3.127.756 3.969 2.14v-7.25h2.863v11.555c0 4.027-2.598 6.645-6.327 6.645-3.777 0-6.424-2.719-6.424-6.67zM234.723 12.479h2.863v12.435h-2.863V12.479zm-.457-3.6c0-1.158.794-2.014 1.9-2.014 1.107 0 1.901.856 1.901 2.014s-.794 1.989-1.901 1.989c-1.106 0-1.9-.831-1.9-1.989zM240.353 20.131v-8.904l2.862-3.153v4.405h6.136v2.718h-6.136v4.934c0 1.662.819 2.316 1.998 2.316 1.178 0 1.996-.63 1.996-2.316v-.328h2.863v.328c0 3.449-1.972 5.11-4.859 5.11-2.888 0-4.86-1.661-4.86-5.11z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_3586_15559">
        <path fill="#fff" d="M0 0H254V31.849H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
